<template>
    <div class="view view--register">
        <register />
    </div>
</template>

<script>
    import register from '../../components/Register.vue';

    export default {
        components: {
            register
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/auth/Register.vue